module.exports = __webpack_public_path__ + "img/step13.eff96947.png";